module.exports = __webpack_public_path__ + "static/media/XRP.af906f89.svg";